<template>
  <div>
    <!--Button-Dialog-Import-->
    <v-dialog v-model="dialogImport" max-width="500px" persistent>
      <template v-slot:activator="{ props }">
        <v-btn
          variant="elevated"
          color="secondary"
          v-bind="props"
          class="ml-2 text-white"
        >
          <span>{{ $t("labels.import-mashup") }}</span>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar flat color="secondary">
          <v-toolbar-title class="text-white">
            {{ $t("labels.import-mashup") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="closeImportMashup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form
            enctype="multipart/form-data"
            ref="importForm"
            v-model="validation"
            lazy-validation
          >
            <v-row no-gutters>
              <v-col cols="12">
                <div class="text-caption">
                  {{ $t("strings.import-info") }}
                </div>
              </v-col>
              <v-col cols="12">
                <div class="text-caption">
                  {{ $t("strings.import-info-nb") }}
                </div>
              </v-col>
              <v-col cols="12">
                <v-list-subheader class="text-primary">{{
                  $t("strings.import-suggest-file")
                }}</v-list-subheader>
                <v-file-input
                  v-model="editedItem.file"
                  accept="application/json, .zip, .dme"
                  color="primary"
                  counter
                  :label="$t('labels.file-input')"
                  :placeholder="$t('strings.select-files')"
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  variant="outlined"
                  density="compact"
                  :rules="!editedItem.url ? [rules.fileRules] : []"
                  :disabled="!!editedItem.url"
                  :required="!!editedItem.url"
                  show-size
                  type="file"
                  ref="file"
                  name="file"
                >
                  <template v-slot:selection="{ fileNames }">
                    <v-chip
                      v-for="fileName in fileNames"
                      :key="fileName"
                      color="primary"
                      label
                      size="small"
                      class="me-2"
                    >
                      {{ fileName }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-col>
              <v-col cols="12">
                <v-list-subheader class="text-primary mt-n4">{{
                  $t("strings.import-suggest-url")
                }}</v-list-subheader>
                <v-text-field
                  v-model="editedItem.url"
                  :label="$t('labels.url')"
                  :hint="$t('strings.mashup-project-url')"
                  persistent-hint
                  variant="outlined"
                  :rules="!editedItem.file ? [rules.urlRules] : []"
                  :required="!!editedItem.file"
                  name="url"
                  density="compact"
                  :disabled="!!editedItem.file"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="auto">
                <v-list-subheader class="text-primary">
                  {{ $t("strings.import-file-format") }}
                </v-list-subheader>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="fromVersion"
                  :items="mashupFileFormats"
                  item-title="name"
                  item-value="value"
                  label=""
                  density="compact"
                  variant="outlined"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            variant="text"
            @click="closeImportMashup"
          >
            {{ $t("labels.cancel") }}
          </v-btn>
          <v-btn
            color="secondary darken-1"
            variant="text"
            :disabled="!validation"
            @click="importMashupConfirm"
            >{{ $t("labels.import") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Button-Dialog-Import-Dependencies-->
    <DialogImportDependencies
      :dialogDependencies="dialogDependencies"
      :dependenciesList="dependenciesList"
      @activateDialogDependencies="dialogDependencies = $event"
      @dependenciesActions="editedItem.dependencies = $event"
    />
  </div>
</template>

<script>
import axios from "axios";
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import DialogImportDependencies from "@/components/DialogImportDependencies.vue";
export default {
  name: "DialogImport",
  components: { DialogImportDependencies },
  mixins: [utils, events],
  props: ["tenantId", "apiUrl", "refreshList"],
  data: function () {
    return {
      dialogImport: false,
      dialogDependencies: false,
      validation: true,
      rules: {
        fileRules: (value) => {
          if (!value) return true; //no files selected
          for (let i = 0; i < value.length; i++) {
            if (value[i].size > 2000000) {
              return this.$t("errors.mashup-import-size");
            }
          }
          return true; //all files are less than 2MB
        },

        urlRules: (value) =>
          (!!value &&
            /^(([^:/?#]+):)(\/\/([^/?#]*))([^?#]*)(\?([^#]*))?(#(.*))?/.test(
              value,
            )) ||
          this.$t("errors.mashup-url-format"),
      },
      mashupFileFormats: [
        { name: "Data Mashup v1.x", value: "v1" },
        { name: "Data Mashup v2.x", value: "v2" },
        { name: "Data Mashup v3.x", value: "v3" },
      ],
      fromVersion: "v3",
      editedItem: {
        file: null,
        url: "",
        dependencies: "",
      },
      defaultItem: {
        file: null,
        url: "",
        dependencies: "",
      },
      fileImport: null,
      dependenciesList: [],
    };
  },
  methods: {
    importMashupConfirm() {
      if (this.importValidateForm()) {
        this.createFormData();
      }
    },
    //Reading local file
    createFormData() {
      if (!this.editedItem.file && !this.editedItem.url) return;
      const formData = new FormData();
      formData.append(
        "file",
        this.editedItem.file.length === 1
          ? this.editedItem.file[0]
          : this.editedItem.file,
      );
      formData.append("url", this.editedItem.url);
      formData.append(
        "dependencies",
        this.editedItem.dependencies?.errors
          ? JSON.stringify(this.editedItem.dependencies.errors)
          : "",
      );
      this.importMashup(formData);
    },
    closeImportMashup() {
      this.dialogImport = false;
      this.$refs.importForm.resetValidation();
      this.$refs.importForm.reset();
      this.resetDialog();
    },
    importValidateForm() {
      return this.$refs.importForm.validate();
    },
    resetDialog() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.fromVersion = "v3";
      });
    },
    //Import a new mashup from file
    importMashup(formData) {
      axios
        .post(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/import?fromVersion=" +
            this.fromVersion,
          formData,
          {
            headers: formData.getHeaders,
            withCredentials: true,
          },
        )
        .then(() => {
          this.closeImportMashup();
          this.resetDialog();
          this.$emit(
            "activateSnackbar",
            true,
            this.$t("strings.import-mashup-text"),
          );
          //Refreshes the Mashup list by getMashupsList from parent
          this.refreshList();
        })
        .catch((error) => {
          if (error.response.data.status == "409") {
            this.activateDependencies(
              true,
              JSON.parse(JSON.stringify(error.response.data)),
            );
          } else {
            this.setError(error, false);
          }
        });
    },
    activateDependencies(status, list) {
      this.dependenciesList = list;
      this.dialogDependencies = status;
    },
  },
};
</script>
